module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('el-col', {
      staticClass: "order_content main_container",
      attrs: {
        "span": 24
      }
    }, [_c('section', {
      staticClass: "model_section"
    }, [_c('p', {
      staticClass: "model_top_title"
    }, [_vm._v("消息中心")]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "margin": "5px 10px 0 0"
      },
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.addNewlyBuild()
        }
      }
    }, [_vm._v("新建")])], 1), _vm._v(" "), _c('div', {
      staticClass: "table_container"
    }, [_c('div', {
      staticClass: "table_inner_container",
      staticStyle: {
        "height": "auto"
      }
    }, [_c('el-table', {
      staticClass: "invoice_tab",
      staticStyle: {
        "height": "auto",
        "max-height": "500px"
      },
      attrs: {
        "data": _vm.dataList,
        "stripe": "",
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "标题",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            attrs: {
              "title": scope.row.title
            }
          }, [_vm._v(_vm._s(scope.row.title))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "发布时间",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.publishTime))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "摘要",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.content))]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "详情",
        "fixed": "right",
        "align": "center"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', {
            staticClass: "handle",
            on: {
              "click": function($event) {
                return _vm.seeNotice(scope.row)
              }
            }
          }, [_c('i', {
            staticClass: "el-icon-view"
          }), _vm._v(" 查看 ")])]
        }
      }])
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "order_toolbar_footer",
      staticStyle: {
        "margin-top": "15px",
        "float": "right"
      },
      attrs: {
        "span": 24
      }
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "current-page": _vm.pageIndex,
        "page-size": 10,
        "total": _vm.totalRowsCount
      },
      on: {
        "current-change": _vm.handleCurrentChange
      }
    })], 1)], 1)])], _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": _vm.titleType,
        "visible": _vm.isToExamine,
        "center": true,
        "width": "30%"
      },
      on: {
        "update:visible": function($event) {
          _vm.isToExamine = $event
        }
      }
    }, [_c('el-form', [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "标题 :",
        "label-width": "80px"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": _vm.seeDis,
        "placeholder": "请输入通知的标题，「限制30个字符」",
        "maxlength": "30"
      },
      model: {
        value: (_vm.brandName),
        callback: function($$v) {
          _vm.brandName = $$v
        },
        expression: "brandName"
      }
    })], 1), _vm._v(" "), (_vm.titleType == '详情') ? _c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "发布时间 :",
        "label-width": "80px"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": _vm.seeDis
      },
      model: {
        value: (_vm.fabuTime),
        callback: function($$v) {
          _vm.fabuTime = $$v
        },
        expression: "fabuTime"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "内容 :",
        "label-width": "80px"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "placeholder": "请输入通知的内容",
        "disabled": _vm.seeDis,
        "autosize": {
          minRows: 3,
          maxRows: 8
        },
        "maxlength": "200",
        "show-word-limit": ""
      },
      model: {
        value: (_vm.anwser),
        callback: function($$v) {
          _vm.anwser = $$v
        },
        expression: "anwser"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "btnDiv"
    }, [(_vm.titleType == '新建通知') ? _c('button', {
      staticClass: "el-button search_btn normal_btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editSubmit()
        }
      }
    }, [_vm._v("发布")]) : _vm._e(), _vm._v(" "), (_vm.titleType == '详情') ? _c('button', {
      staticClass: "el-button cancle",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.endRefuse()
        }
      }
    }, [_vm._v("关闭")]) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "提示",
        "visible": _vm.seeFb,
        "center": true,
        "width": "30%",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.seeFb = $event
        }
      }
    }, [_c('el-form', [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "标题 :",
        "label-width": "120px"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.echoTitle))])]), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "发布时间 :",
        "label-width": "120px"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.releaseTime))])])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.rejectToExamine()
        }
      }
    }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          _vm.seeFb = false
        }
      }
    }, [_vm._v("取消")])], 1)], 1)
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77a4f65d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/noticeList.vue
// module id = 1713
// module chunks = 3